// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Uakr","label":"styles_label__3PErn"};